import React from 'react';
import { makeStyles } from '@material-ui/core';
import { MenuInformation } from '../Shared';



const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  boxIcon: {
    backgroundColor: theme.palette.primary.light,
    width: 40,
    height: 40,
    borderRadius: '50%',
    marginRight: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    color: theme.palette.primary.main,
    fontSize: 27,
  },
  title: {
    color: theme.palette.neutrals.low.dark,
    fontWeight: 600,
    fontSize: 20.25,
    margin: theme.spacing(0, 1)
  },
}));

function CurationTitle({ title, icon, info }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.boxIcon}>
        {icon}
      </div>
      <div className={classes.title}>
        {title}
      </div>
      <MenuInformation>
        {info}
      </MenuInformation>
    </div>
  );
}

export { CurationTitle };
